// Module
var code = `<section class="multiple-camera-help-wrapper" role="status" aria-live><p translate="activity-editor-new_multiple-cameras-help"></p><a class="tertiary-btn light" ng-href="{{\$ctrl.data.linkUrl}}" target="_blank" translate="common_more-info-capitalized"></a></section>`;
// Exports
export default code;